export default {"src":"/_next/static/media/cash_out.4bf88f21.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};